import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FileButton as MantineFileButton } from '@mantine/core';
import { Button as XenButton } from '../button';
export const FileButton = forwardRef(({ children, buttonProps, ...props }, ref) => (_jsx(MantineFileButton, { ...props, children: (innerProps) => {
        return (_jsx(XenButton, { ...innerProps, ...buttonProps, ref: ref, children: children }));
    } })));
FileButton.displayName = 'FileButton';
